import AddToCartFormik from '@jetshop/core/components/Mutation/AddToCartFormik';
import React from 'react';
import { toast } from 'react-toastify';
import addToCartMutation from '../../Cart/addToCart.gql';
import CartQuery from '../../Cart/CartQuery.gql';
import ProductToastWrapper from './ProductToast';

const AddToCartForm = ({ children, product, variant, getMissingOptions }) => {
  const onAddToCartInit = ({ mutationId, quantity, price }) => {};
  const onAddToCartError = () => {
    return ({ selectedVariation, mutationId, quantity, price, error }) => {};
  };
  return (
    <AddToCartFormik
      onAddToCartInit={onAddToCartInit}
      onAddToCartError={onAddToCartError}
      cartQuery={CartQuery}
      cartMutation={addToCartMutation}
      product={product}
      variant={variant}
      getMissingOptions={getMissingOptions}
    >
      {() => children}
    </AddToCartFormik>
  );
};

export default AddToCartForm;
